import { apiUri } from '../appConfig';
import handleErrorRequest from './handleErrorRequest';

const themeDetail = (id) => (
	fetch(`${apiUri}/theme/${id}`)
		.then((res) => handleErrorRequest(res))
);

export default themeDetail;



// WEBPACK FOOTER //
// ./src/js/request/themeDetail.js